module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-23-689a53704fb8d5eecab28c7a53a35a43.png";